// Implement logic needed for room selection for a single room.
// Operates closely with `room-card` and `rooms-form` Stimulus controllers.
stimulusApp.register(
  "rooms-group",
  class extends Stimulus.Controller {
    static outlets = ["room-card", "popup-modal"]
    static targets = [
      "description",
      "guestPrice",
      "agencyPrice",
      "changeLabel",
      "input",
      "feedIds",
      "container",
    ]
    static values = {
      index: Number,
    }
    static classes = ["unselected"]

    connect() {
      this._selectedRoomData = null

      if (this.hasIndexValue) {
        const template = document.querySelector(
          `#group-overlay-${this.indexValue}`,
        )
        this.overlayTemplate = template
      }
      this.scrollToElementBind = this.#scrollToElement.bind(this)
    }

    roomCardOutletConnected(outlet, _element) {
      if (this._remainingCapacity) {
        outlet.updateAvailability(this._remainingCapacity)
      }
    }

    expand({ focusTarget }) {
      if (Detector.isMobile) {
        if (focusTarget) {
          this.focus(focusTarget)
        } else {
          document.querySelector(
            "#rooms_group_popup_modal_container",
          ).innerHTML = this.overlayTemplate.innerHTML
        }
      } else {
        this.focus(focusTarget)
        this.element.classList.add("rooms-group_expanded")
      }
    }

    focus(el) {
      // no el or el goes after this.element
      if (!el || $(el).index() > $(this.element).index()) {
        el = this.element
      }
      this.scrollElement = el
      // Trying to scroll while popup modal is still open will fail because
      // of the overlay preventing scrolling, so wait until it is closed.
      if (this.hasPopupModalOutlet && this.popupModalOutlet.isOpen()) {
        addEventListener("hb:popup-closed", this.scrollToElementBind)
      } else {
        // `focus` can happen right after `hasPopupModalOutlet` has closed,
        // so it needs safety delay
        setTimeout(() => {
          Viewport.scrollTo(jQuery(el))
        }, 50)
      }
    }

    #scrollToElement() {
      Viewport.scrollTo(jQuery(this.scrollElement))
      removeEventListener("hb:popup-closed", this.scrollToElementBind)
    }

    collapse() {
      if (Detector.isMobile) {
        this.popupModalOutlet.close()
      } else {
        this.element.classList.remove("rooms-group_expanded")
      }
    }

    selectRoom({ description, price }) {
      // Safeguard error checking, expected to never happen.
      if (!this.selectedRoom()) {
        Bugsnag.notify("Hotwire booking flow error", {
          clientParams: {
            issue: "Rooms was selected but there's no selected room",
          },
        })
      }

      const selectedInput = this.selectedRoom().selectedInput()
      const feedInputs = JSON.parse(selectedInput.dataset.feedIds).map(
        (feedId) => {
          const input = document.createElement("input")
          input.type = "hidden"
          input.name = this.feedIdsTarget.dataset.inputName
          input.value = feedId ?? ""
          return input
        },
      )
      this.feedIdsTarget.replaceChildren(...feedInputs)

      if (this.hasInputTarget) {
        // only mobile has inputTarget
        this.inputTarget.value = selectedInput.value
      }
      this.#saveSelectedRoomData()

      this.collapse()
      this.#updateDescription(description)
      this.#updatePrice(price)
      this.#updateChangeLabel()
      this.element.dispatchEvent(
        new CustomEvent("hb:room-selected", {
          bubbles: true,
          cancelable: true,
        }),
      )
    }

    selectedRoom() {
      return this.roomCardOutlets.find((room) => {
        return room.selected()
      })
    }

    #saveSelectedRoomData() {
      const selectedRoom = this.selectedRoom()
      const prices = selectedRoom.rawSelectedPrices()
      this._selectedRoomData = {
        guestPrice: prices.guest,
        agencyPrice: prices.agency,
        roomQuantities: selectedRoom.roomQuantitiesValue,
      }
    }

    getSelectedRoomData() {
      return this._selectedRoomData
    }

    updateAvailability(remainingCapacity) {
      // roomCardOutlets isn't always available on mobile,
      // they get updated in `roomCardOutletConnected`
      if (Detector.isMobile) {
        this._remainingCapacity = remainingCapacity
      } else {
        this.roomCardOutlets.forEach((room) => {
          room.updateAvailability(remainingCapacity)
        })
      }
    }

    highlight() {
      if (Detector.isDesktop) return
      this.containerTarget.classList.add(this.unselectedClass)
    }

    unhighlight() {
      if (Detector.isDesktop) return
      this.containerTarget.classList.remove(this.unselectedClass)
    }

    #updateDescription = (description) => {
      if (this.hasDescriptionTarget) {
        this.descriptionTarget.removeAttribute("dir")
        description ||= this.selectedRoom().descriptionValue
        this.descriptionTarget.innerHTML = description
      }
    }

    #updatePrice = (price) => {
      price ||= this.selectedRoom()?.selectedPrice()
      if (this.hasGuestPriceTarget && price.guest) {
        this.guestPriceTarget.innerHTML = price.guest
        this.guestPriceTarget.parentElement.classList.remove("hidden")
      }
      if (this.hasAgencyPriceTarget && price.agency) {
        this.agencyPriceTarget.innerHTML = price.agency
        this.agencyPriceTarget.parentElement.classList.remove("hidden")
      }
      if (this.hasDescriptionTarget) {
        this.descriptionTarget.classList.add(
          "rooms-group-selection--rooms_selected",
        )
      }
    }

    #updateChangeLabel = () => {
      if (this.hasChangeLabelTarget) {
        this.changeLabelTarget.innerHTML = this.selectedRoom()
          ? this.changeLabelTarget.dataset.change
          : this.changeLabelTarget.dataset.choose
      }
    }
  },
)
